import styled from "styled-components"
import { Container } from "@mui/material"

export const Wrapper = styled(Container)`
  padding-top: 4em;
  padding-bottom: 4em;

  .wrapper {
    text-align: center;

    iframe {
      height: 85vh;
      width: 95%;
    }
  }
`
